"use client";
'use strict';

var React = require('react');
var browser = require('@sravni/ab-testing-sdk/lib/browser');
var Context = require('./Context.js');

function UncontrolledAbTestingProvider(props) {
    const { initialValue: params, children } = props;
    const sdk = React.useMemo(() => (params ? new browser.AbTestingSdk(params) : Context.DEFAULT_VALUE), [params]);
    const [currentSdk] = React.useState(sdk);
    return React.createElement(Context.AbTestingContext.Provider, { value: currentSdk }, children);
}

exports.UncontrolledAbTestingProvider = UncontrolledAbTestingProvider;
//# sourceMappingURL=Uncontrolled.js.map
